import { ListPaginationMeta } from "utils/helpers/pagination";

export const Filter = {
  Year: "year",
  LicenseWeight: "licenseWeight",
  SuperModel: "superModel",
  Manufacturer: "manufacturer",
} as const;

export type FilterKey = typeof Filter[keyof typeof Filter];

export type ModelFormDropDownKey = "manufacturers" | "superModels";

export type ModelFormDropDownOption = {
  id: number;
  name: string;
};

export type ModelFormDropDownState = {
  items: ModelFormDropDownOption[];
  page: number;
  perPage: number;
  meta: ListPaginationMeta;
  loading: boolean;
};

export type ModelFormDropDowns = Record<
  ModelFormDropDownKey,
  ModelFormDropDownState
>;

export type ManufacturerModelManufacturerFilter = "ALL" | string;
export type ManufacturerModelManufacturerOptions = { id: number; name: string }[];

export type ManufacturerModelMasterModelFilter = "ALL" | string;
export type ManufacturerModelMasterModelOptions = { id: number; name: string }[];

export type ManufacturerModelYearFilterOptions = number[];

export type ManufacturerModelYearFilter = "ALL" | number;

export type ManufacturerModelLicensingWeightFilter = "ALL" | number;

export type ManufacturerModelLicensingWeightOptions = number[];

export interface ManufacturerModelDetail {
  manufacturerModelID: number;
  manufacturerID: number;
  manufacturerName: string;
  year: number;
  modelDesc: string;
  chassisWidth: number;
  chassisHeight: number;
  baseBeamType: string;
  maxWidth: number;
  frontExtension: number;
  licenseWeight: number;
  weelDrive: string;
  baseBeamTypeRoof: string;
  chassisWeight: number;
  frontWeelBase: number;
  teken95SideLight?: string | null;
  teken95SideShld?: string | null;
  teken95MadShld?: string | null;
  registrationOrderNumber?: string | null;
  remarks?: string | null;
  sideLighting?: boolean;
  sideGuard?: boolean;
  mudguard?: boolean;
  extendableChassis?: boolean;
}

export interface ManufacturerModelRow {
  manufacturerModelID: number;
  manufacturerID: number;
  manufacturerName: string;
  year: number;
  modelDesc: string;
  superModelID: number;
  superModelName: string;
  chassisWidth: number;
  chassisHeight: number;
  baseBeamType: string;
  maxWidth: number;
  frontExtension: number;
  licenseWeight: number;
  weelDrive: string;
  baseBeamTypeRoof: string;
  chassisWeight: number;
  frontWeelBase: number;
  sideLighting?: boolean;
  sideGuard?: boolean;
  mudguard?: boolean;
  extendableChassis?: boolean;
}

export interface ManufacturerModelTechSpecRow {
  id: string;
  driverCabinType: string;
  tire: string | null;
  classType: string | null;
  weight: string | null;
  axlesMeasure: number | null;
  lowerLimit: number | null;
  upperLimit: number | null;
  frontLoad: string | null;
  rearAxlesMeasure: string | null;
  notes: string | null;
  requiresPlan: string | null;
  dhType: string;
  bodyType: string | null;
}

export interface ManufacturerModelForm {
  manufacturerID: string;
  year: string;
  modelDesc: string;
  chassisWidth: string;
  chassisHeight: string;
  baseBeamType: string;
  maxWidth: string;
  frontExtension: string;
  licenseWeight: string;
  weelDrive: string;
  baseBeamTypeRoof: string;
  chassisWeight: string;
  frontWeelBase: string;
  registrationInstruction: string;
  sideLighting: boolean;
  sideGuard: boolean;
  mudguard: boolean;
  extendableChassis: boolean;
  notes: string;
}
export type ManufacturerModelListMeta = ListPaginationMeta;

export interface ManufacturerModelListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: ManufacturerModelRow[];
  meta?: ManufacturerModelListMeta;
}

export interface ManufacturerModelFilterOptionsResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: {
    options: ModelFormDropDownOption[];
  };
  meta?: ManufacturerModelListMeta;
}

export interface ManufacturerModelState {
  loading: boolean;
  list: ManufacturerModelRow[];
  page: number;
  perPage: number;
  meta: ManufacturerModelListMeta;
  error: string | null;
  manufacturerFilter: ManufacturerModelManufacturerFilter;
  manufacturerOptions: ManufacturerModelManufacturerOptions;
  masterModelFilter: ManufacturerModelMasterModelFilter;
  masterModelOptions: ManufacturerModelMasterModelOptions;
  yearFilter: ManufacturerModelYearFilter;
  yearFilterOptions: ManufacturerModelYearFilterOptions;
  licensingWeightFilter: ManufacturerModelLicensingWeightFilter;
  WeightFilterOptions: ManufacturerModelLicensingWeightOptions;
  isAddModalOpen: boolean;
  form: ManufacturerModelForm;
  selectedId: number;
  modelFormDropDowns: ModelFormDropDowns;
}
